import { createContext, useContext } from 'react';

import { WidgetPoiProviderType } from 'extensions/widget/models/widget-poi-provider-type';

export const FeatureContext = createContext<WidgetPoiProviderType>({} as WidgetPoiProviderType);

export const useFeatureContext = () => {
    return useContext(FeatureContext);
};
